export const CREATE_OR_UPDATE_TEST_CASE = "CREATE_TEST_CASE";
export const SAVING_TEST_CASE = "SAVING_TEST_CASE";
export const TEST_CASE_UPDATE_STATUS = "TEST_CASE_UPDATE_STATUS";
export const RECEIVED_TEST_CASES = "RECEIVED_TEST_CASES";
export const FETCHING_TEST_CASES = "FETCHING_TEST_CASES";
export const CLEAR_TEST_CASE_RESULTS = "CLEAR_TEST_CASE_RESULTS";
export const CLEAR_TEST_CASE_UPDATE_STATUS = "CLEAR_TEST_CASE_UPDATE_STATUS";


// WEBPACK FOOTER //
// ./src/actions/types.js